import React, { createContext, useContext, useState, useCallback } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

const Ctx = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false, title: "", description: "", danger: false, confirmLabel: "Confirm", resolve: null });
  const confirm = useCallback((opts) => new Promise((resolve) => {
    setState({
      open: true,
      title: opts.title || "Are you sure?",
      description: opts.description || "",
      danger: !!opts.danger,
      confirmLabel: opts.confirmLabel || (opts.danger ? "Delete" : "Confirm"),
      resolve,
    });
  }), []);
  const close = (val) => { state.resolve?.(val); setState(s => ({ ...s, open: false })); };
  return (
    <Ctx.Provider value={confirm}>
      {children}
      <AlertDialog open={state.open} onOpenChange={o => { if (!o) close(false); }}>
        <AlertDialogContent className="bg-[#0a0a0a] border-white/10 text-white rounded-none">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-display text-2xl uppercase">{state.title}</AlertDialogTitle>
            {state.description && <AlertDialogDescription className="text-zinc-400">{state.description}</AlertDialogDescription>}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => close(false)} className="rounded-none border-white/20 text-white bg-transparent hover:bg-white/5" data-testid="confirm-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => close(true)} className={`rounded-none ${state.danger ? "bg-red-600 hover:bg-red-700" : "bg-white text-black hover:bg-zinc-200"}`} data-testid="confirm-ok">{state.confirmLabel}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Ctx.Provider>
  );
}

export const useConfirm = () => useContext(Ctx);
